"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPERTY_TYPE = exports.STRING_CONVERT_RULE = void 0;
exports.STRING_CONVERT_RULE = {
    toHalfLower: 'toHalfLower',
    toHalfUpper: 'toHalfUpper',
    fullToHalf: 'fullToHalf',
    halfToFull: 'halfToFull',
    toFullHiragana: 'toFullHiragana',
    toHalfKatakana: 'toHalfKatakana',
    toFullKatakana: 'toFullKatakana',
};
exports.PROPERTY_TYPE = {
    mailAddress: 'mailAddress',
    text: 'text',
    number: 'number',
    date: 'date',
    monthDay: 'monthDay',
    singleSelection: 'singleSelection',
    multipleSelection: 'multipleSelection',
    mailRefusalFlag: 'mailRefusalFlag',
    passwordHash: 'passwordHash',
    authentication: 'authentication',
    fileUpload: 'fileUpload',
    staticContent: 'staticContent',
};
